import React from 'react'

function OrdinaryDifferentiation() {
    return (

        
        <div className='entire_page'>
            <div className='super_header'>
                <h2>
                    This is Ordinary Differentiation
                </h2>
            </div>

        </div>
        
    )
}

export default OrdinaryDifferentiation